<template>
  <div class="checkoutColumns">
    <div class="checkoutColumn formsCol">
      <div id="app" class="neouCheckout" :class="[screens[plansIndex].toLowerCase(), checkoutVersion]">
        <div class="checkoutBox">
          <component
            class="checkoutBoxInner"
            v-bind:is="activeComponent"
            @nextScreen="handleNextScreen"
            @selectedPlan="handleSelectedPlan"
            @warningMessage="warningMessage"
            @setUser="setUser"
            @setEmail="setEmail"
            @setStripeId="setStripeId"
            @setPaymentId="setPaymentId"
            v-bind:selectedPlan="selectedPlan"
            v-bind:user="user"
            v-bind:email="email"
            v-bind:stripeId="stripeId"
            v-bind:paymentId="paymentId"
          ></component>
          <div v-if="messages" class="messageBox">{{ messages }}</div>
        </div>
      </div>
    </div>
    <div class="checkoutColumn trainerCol">
      <img src="https://res.cloudinary.com/dd1ldy5zw/image/upload/c_scale,q_auto:eco,w_800/v1640009912/christi-joseph-medium.png" class="christiJoseph short">
      <img src="https://res.cloudinary.com/dd1ldy5zw/image/upload/c_scale,q_auto:eco,w_800/v1640016060/christi-joseph-tall.png" class="christiJoseph tall">
    </div>
  </div>
</template>

<script>
import Login from "./components/Login.vue";
import Checkout from "./components/Checkout.vue";
import Plans from "./components/Plans.vue";
// import PlanVariantC from "./components/PlanVariantC.vue";
import Onboarding from "./components/Onboarding.vue";
import Redeem from "./components/Redeem.vue";
import Final from "./components/Final.vue";
import FirstRun from "./components/FirstRun.vue";

import LightLogin from "./components/LightLogin.vue";
import LightCheckout from "./components/LightCheckout.vue";
import LightFinal from "./components/LightFinal.vue";
// Cap One Stuff
import CapitalOneLogin from "./components/CapitalOneLogin.vue";
import CapitalOneSetPassword from "./components/CapitalOneSetPassword.vue";
import CapitalOneSetEmail from "./components/CapitalOneSetEmail.vue";

export default {
  name: "App",
  components: {
    Login,
    LightLogin,
    Plans,
    Checkout,
    LightCheckout,
    Onboarding,
    Redeem,
    Final,
    LightFinal,
    FirstRun,
    CapitalOneLogin,
    CapitalOneSetPassword,
    CapitalOneSetEmail
  },
  data: () => ({
    screens: ["Login", "Onboarding", "Plans", "Checkout", "FirstRun", "Final"],
    plansIndex: 0,
    selectedPlan: "",
    messages: "",
    show: false,
    user: "",
    email: "",
    stripeId: "",
    paymentId: "",
    checkoutVersion: window.checkoutVersion || "default"
  }),
  beforeMount: function() {
    if ('neouFlow' in window){
      this.screens = window.neouFlow;
    }
  },
  methods: {
    handleNextScreen: function() {
      this.screens = window.neouFlow || [
        "Login",
        "Onboarding",
        "Plans",
        "Checkout",
        "FirstRun",
        "Final"
      ];
      this.plansIndex++;
    },
    handleSelectedPlan: function(planId) {
      this.selectedPlan = planId;
    },
    setUser: function(userId) {
      this.user = userId;
    },
    warningMessage: function(message) {
      console.log(message);
      var self = this;
      self.messages = message;
      setTimeout(function() {
        self.messages = "";
      }, 5 * 1000);
    },
    setEmail: function(email) {
      this.email = email;
    },
    setStripeId: function(stripeId) {
      this.stripeId = stripeId;
    },
    setPaymentId: function(paymentId) {
      this.paymentId = paymentId;
    },
    close:function(){
      var checkoutClosedEvent = new Event("checkoutClosed");
      window.dispatchEvent(checkoutClosedEvent);
    }
  },
  computed: {
    activeComponent: function() {
      return this.screens[this.plansIndex];
    }
  }
};
</script>

<style lang="scss">

.neouCheckout {
  display: block;
  align-items: flex-start;


}
.light{
  font-family:'Prox';

  .checkoutBox {
    width: 100%;
    max-width:530px;
    border-radius: 0px;
    position: relative;
    color: #ffffff;
    display: flex;
    justify-content: center;
    //overflow: hidden;
    margin:0px auto;
  }

 .checkoutOverlay{
    display:none;
  }
.scrollable {
  justify-content: center;
  min-height: 800px;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height:100%;
}
.closeIcon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 20;
  font-size:35px;
  color:#000000;
  &:hover {
    opacity: 0.6;
  }
  span{
    display:block;
    transform:rotate(-45deg);
  }
}
.neouButton {
  width: 100%;
  border: none;
  cursor: pointer;
  height: 40px;
  outline: none;
  line-height: 40px;
  font-size: 13px;
  background: linear-gradient(45deg, #22d6fe, #51fbfe);
  margin-top: 24px;
  font-family: "prox", Helvetica, Arial, sans-serif;
  line-height: 20px;
  border-color: black;
  border-radius: 6px;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-sizing: border-box;
  font-weight: bold;
  position: relative;
  margin: 0;
  .md-icon {
    position: absolute;
    left: -45px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 100;
  }
  &.facebook {
    width: 100%;
    height: 40px;
    border: none;
    font-size: 13px;
    border-radius: 6px;
    border-color: black;
    background: #4267b2;
    color: #ffffff;
    margin: 0px;
    margin-bottom: 20px;
    text-transform: none;
  }
  &.apple {
    background: #000;
    font-size: 13px;
    text-transform: none;
    color:#fff;
  }
}
.md-button.md-raised:not([disabled]){
  box-shadow:none;
}
.messageBox {
  position: fixed;
  left: 15px;
  bottom: 30px;
  border-radius: 4px;
  padding: 15px 20px;
  background-color: rgb(49, 49, 49);
  z-index: 9;
}
.checkoutOverlay{
  background:rgba(5,6,6,0.8);
  width:100%;
  height:100%;
  position:absolute;
  top:0px;
  left:0px;
  right:0px;
  bottom:0px;
}

// DEFAULT STYLES

}
.default{
  .checkoutBox {
  max-height: 728px;
  min-height: 720px;
  height: 100vh;
  width: 100%;
  border-radius: 6px;
  margin: 0px 30px 30px 30px;
  position: relative;
  color: #ffffff;
  display: flex;
  justify-content: center;
  background: rgb(8, 11, 11);
  //overflow: hidden;
}
.scrollable {
  justify-content: center;
  min-height: 800px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.closeIcon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 20;
  font-size:35px;
  color:#FFFFFF;
  &:hover {
    opacity: 0.6;
  }
  span{
    display:block;
    transform:rotate(-45deg);
  }
}
.neouButton {
  width: 100%;
  border: none;
  cursor: pointer;
  height: 40px;
  outline: none;
  line-height: 40px;
  font-size: 13px;
  background: linear-gradient(45deg, #22d6fe, #51fbfe);
  margin-top: 24px;
  font-family: "prox", Helvetica, Arial, sans-serif;
  line-height: 20px;
  border-color: black;
  border-radius: 6px;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-sizing: border-box;
  font-weight: bold;
  position: relative;
  margin: 0;
  .md-icon {
    position: absolute;
    left: -45px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 100;
  }
  &.facebook {
    width: 100%;
    height: 40px;
    border: none;
    font-size: 13px;
    border-radius: 6px;
    border-color: black;
    background: #4267b2;
    color: #ffffff;
    margin: 0px;
    margin-bottom: 20px;
    text-transform: none;
  }
  &.apple {
    background: #fff;
    font-size: 13px;
    text-transform: none;
  }
}
.messageBox {
  position: fixed;
  left: 15px;
  bottom: 30px;
  border-radius: 4px;
  padding: 15px 20px;
  background-color: rgb(49, 49, 49);
  z-index: 9;
}
}

body{
  background-image: linear-gradient(180deg, #FFFFFF 0%, #F2F4F6 100%);
  height:100%;
}
.christiJoseph{
  max-width:180px;
  margin:0px auto;
  display:block;

  &.tall{
    display:none;
  }
}

.checkoutColumns{
  height:100%;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
}

@media screen and (min-width:768px) {
  .checkoutColumns{
    display:flex;
    flex-direction:row;
    align-items:center;
    max-width:1500px;
    margin:0px auto;
    padding:0px 20px;
  }

  .formsCol{
    flex:1 0 400px;
  }

  .trainerCol{
    align-self:stretch;
    display:flex;
    justify-content:flex-end;
  }

  .christiJoseph{
    width:80%;
    max-width:initial;
    margin-top:40px;
    align-self:flex-end;

    &.short{
      display:none;
    }
    
    &.tall{
      display:block;
    }
  }
  
}
</style>
